var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "mainWrapper" },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-section", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c(
            "el-main",
            {
              staticStyle: {
                padding: "0",
                overflow: "visible",
                "margin-top": "6px"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _vm.isLoading
                        ? [
                            _c(
                              "article",
                              { staticClass: "blog-post" },
                              [_c("loading-skeleton")],
                              1
                            )
                          ]
                        : [
                            _c("article", { staticClass: "blog-post" }, [
                              _c("header", { staticClass: "blog-header" }, [
                                _c("h1", {
                                  staticClass: "blog-title",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.blogDetail.title)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "blog-meta" }, [
                                  _c(
                                    "time",
                                    {
                                      attrs: {
                                        datetime: _vm.blogDetail.publishedOn
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.blogDetail.publishedOn
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.blogDetail.imageUrl
                                ? _c(
                                    "div",
                                    { staticClass: "blog-featured-image" },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.blogDetail.imageUrl,
                                          alt: _vm.blogDetail.blogDetail
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "blog-content",
                                domProps: {
                                  innerHTML: _vm._s(_vm.blogDetail.content)
                                }
                              }),
                              _vm._v(" "),
                              _c("footer", { staticClass: "blog-footer" })
                            ])
                          ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0182ef54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0182ef54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/blogView.vue
// module id = null
// module chunks = 